import type { people as peopleEn } from "../en/people";

// Karty lidí (týmy destinací): editor karty s rolí u každé destinace, seznam karet a odkaz
// na profil průvodce.
export const people: typeof peopleEn = {
  edit: {
    roleAtDestination: "Role u destinace",
    sortAtDestination: "Pořadí u destinace",
    othersLabel: "U destinace dále:",
    othersNone: "U destinace zatím nikdo další.",
    otherItem: "{{name}} ({{role}}, pořadí {{order}})",
    inactive: "neaktivní",
    noDestinations: "Karta bez destinací se na stránkách destinací neukáže.",
    guideProfile: "Profil průvodce",
    guideProfileNone: "Bez profilu průvodce",
    guideProfileHint: "Odkaz na profil se na webu ukáže jen u aktivního průvodce.",
  },
  list: {
    rolesColumn: "Role",
    allRoles: "Všechny role",
    noDestinations: "Bez destinací — na stránkách destinací se neukáže",
  },
};
